  <template>
  <div v-if="!(['Login','Register'].includes($route.name))" uk-sticky="media: 960" class="uk-navbar-container" style="z-index: 2; position: relative;">
    <nav class="main-navbar uk-container uk-container-expand uk-light">
      <div class="uk-navbar">
        <div class="uk-navbar-left">
          <!-- LOGO -->
          <router-link to="/" class="uk-navbar-item uk-logo uk-padding-remove">
          <div style="width: 162px; float: left;">
              <svg width="100%" height="100%" viewBox="0 0 441 49" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;">
                  <g transform="matrix(1,0,0,1,-217.867,-443.326)">
                      <g transform="matrix(4.97792,0,0,5.01892,-1101.74,-1983.69)">
                          <text x="264.983px" y="492.946px" font-family="Comfortaa" style="font-size:12px;fill:white;">W<tspan x="274.919px " y="492.946px ">a</tspan>termarks</text>
                          <text x="339.647px" y="492.946px" font-family="Comfortaa" style="font-size:12px;fill:rgb(255,191,0);">.io</text>
                      </g>
                  </g>
              </svg>
          </div>
          </router-link>
        </div>
        <div class="uk-navbar-center">
          <ul class="uk-navbar-nav">
            <li>
                <router-link to="/apply" class="navbar-text">Apply</router-link>
            </li>
            <li id="createNav">
              <router-link to="/design" class="navbar-text">Create</router-link>
            </li>
            <li>              
              <router-link to="/gallery" class="navbar-text">Gallery</router-link>
            </li>
          </ul>
        </div>
        <div class="uk-navbar-right">
          <div class="uk-navbar-item uk-padding-remove-right">
            <ul class="uk-grid-small uk-grid">
              <!-- Help -->
              <li>
                <router-link to="/help" class="uk-icon-button uk-icon"  uk-tooltip="title: Help; pos: bottom" style="text-decoration: none;">
                  <i class="material-icons">help_outline</i>
                </router-link>               
              </li>           
              <div uk-dropdown="pos: left-center; animation: uk-animation-slide-right-small" class="help-dropdown">
                <div class="uk-width-large">
                  <ul class="uk-navbar-nav">
                    <li>
                      <a @click="openTutorialModal()" class="navbar-text navbar-help-text"><i class="material-icons uk-inline" style="margin-right: 4px;">school</i> Tutorial</a>
                    </li>
                    <li>              
                      <a @click="openFeedback()" class="navbar-text navbar-help-text"><i class="material-icons uk-inline" style="margin-right: 4px;">comment</i> Feedback</a>
                    </li>
                  </ul>
                </div>
              </div>                                              
              <!-- Profile -->
              <li class="uk-animation-slide-right-small" v-if="globalSessionInfo.currentUser.isLoggedIn">
                <a class="uk-thumb" href="#">
                  <img class="uk-border-circle" style="box-shadow: 0px 0px 0px 2px rgba(255,255,255,1);" width="36" :src="globalSessionInfo.currentUser.photoURL" uk-tooltip="title: Profile; pos: bottom">
                </a>
                <!-- Upgrade Hover Over 
                <div style="border-radius: 5px;" uk-dropdown>
                
                  <div class="speech-bubble uk-animation-slide-left-small">                    
                    <div class="features-box">
                      <div class="features-box-content">
                        <legend data-v-9dc1a6fc="" class="uk-legend uk-text-center"><span class="uk-inline uk-margin-small-right"><i class="material-icons" style="font-size: 38px;">terrain</i></span> Upgrade</legend>
                        <hr style="border-top: 1px solid #e5e5e5; margin-top: 5px;">                                      
                        <div class="uk-grid-collapse uk-grid uk-margin-top" uk-grid="">          
                            <div class="uk-width-auto uk-first-column"><i class="material-icons wm-red">all_inclusive</i></div>
                            <div class="uk-width-expand uk-margin-small-left">
                              <b>Unlimited Watermarking</b>
                              <br><span class="uk-text-small">Apply watermarks to 50+ images at a time!</span>
                            </div>
                        </div> 
                        <div class="uk-grid-collapse uk-grid uk-margin-top" uk-grid="">
                            <div class="uk-width-auto uk-first-column"><i class="material-icons wm-blue">photo_library</i></div>
                            <div class="uk-width-expand uk-margin-small-left">
                              <b>Gallery</b>
                              <br><span class="uk-text-small">All images will be uploaded to secure cloud. Organize and share albums.</span>                
                            </div>
                        </div> 
                        <div class="uk-grid-collapse uk-grid uk-margin-top" uk-grid="">
                            <div class="uk-width-auto uk-first-column"><i class="material-icons wm-yellow">share</i></div>
                            <div class="uk-width-expand uk-margin-small-left">
                              <b>Share</b>
                              <br><span class="uk-text-small">Share images to social media or share using a secure link.</span>
                            </div>
                        </div> 
           
                        <hr style="border-top: 1px solid #e5e5e5;">      
                        <div class="uk-flex uk-flex-center uk-margin-top">
                          <a class="uk-button shiny uk-margin uk-width-1-2" style="font-size: 16px; border-radius: 2px;"><b>Upgrade</b></a>
                        </div>                                       
                      </div>
                    </div> 
                  </div>                  
                  <ul class="uk-nav uk-dropdown-nav dropdown-background">
                      <li class="wm-green2 uk-margin-bottom-small" style="font-size: 16px;">{{globalSessionInfo.currentUser.displayName}}</li> 
                      <li><a href="#"><span class="uk-inline uk-margin-small-right"><i class="material-icons">terrain</i></span>  <b>Upgrade</b></a></li>        
                      <li><a href="#"><span class="uk-inline uk-margin-small-right"><i class="material-icons">settings</i></span>  Settings</a></li>                                                              
                      <li><a @click="logout" href="#"><span class="uk-inline uk-margin-small-right uk-"><i class="material-icons">account_circle</i></span> Logout</a></li>                      
                      <li style="height: 40px;"></li>             
                  </ul>                       
                  </div> --> 
                  <!-- SIMPLE LOGOUT dropdown -->
                  <div class="logout-dropdown uk-padding-small" style="min-width: 180px;" uk-dropdown="mode: click">
                    <div class="logout-dropdown">       
                      <div class="account-header">                  
                        <div class="uk-text-small"><span class="uk-inline wm-green2 uk-margin-small-right"><i class="material-icons">account_circle</i></span> <b>{{globalSessionInfo.currentUser.displayName}}</b></div>                      
                        <div class="uk-text-small uk-text-center uk-margin-left-small"><b>{{globalMarks.savedMarks.length}}</b> saved mark(s)</div>      
                      </div>                                      
                        <button @click="logout" class="uk-button uk-button-hollow uk-width-1-1" style="border-radius: 2px;">Logout <i class="material-icons uk-inline">exit_to_app</i></button>                      
                    </div>
                  </div>                    
              </li>  
              <!-- Login -->  
              <li v-else>
                <router-link to="/login" class="uk-icon-button li-lo">
                  <span class="li-lo-text">Login</span>
                </router-link>
                <router-link to="/register" class="uk-icon-button li-lo uk-margin-small-left uk-text-bold">
                  <span class="li-lo-text">Sign Up</span>
                </router-link>                
              </li>                                        
            </ul>
          </div>
        </div>
      </div>
    </nav>          
  </div>
  </template>

  <script>
  import firebase from 'firebase/app'

  export default {
    name: 'Navbar',
    data () {
      return {
      }
    },
    methods: {
      logout() {
        UIkit.modal.confirm('<b>Sign out?</b> <br> Logging out may cause any unsaved work to be lost.')
          .then(function () {
            firebase.auth().signOut()
              .then(function() {
                // Sign-out successful.
                UIkit.notification({message: '<i class="material-icons uk-inline wm-green2">how_to_reg</i> You have been signed out.', pos: 'bottom-center'}) 
                // main.js has firebase.auth().onAuthStateChanged(function() which watches user state change and will remove global session data on user
              })
              .catch(function(error) {
                // An error happened
              }); 
        }, function () {
        });      
      },
      openFeedback() {
        // feedback module and logic live in App.vue so they can be accessible by all components
        UIkit.modal('#export-feedback-modal', {bgClose:false, bgEsc:false}).show();    
      },
      openTutorialModal() {
        UIkit.modal('#how-to-guide').show();
      }
    }    
  }
</script>

<style scoped>
  .uk-navbar-container {
    background: none !important;
  }

  .dropdown-background {
    background-repeat: off;
    background: url('/img/illustrations/doodles/take_off.svg') bottom right no-repeat;
    background-size: 140px auto;
    background-position: right -55px bottom 0; 
  }

  .speech-bubble {
    position: absolute;
    left: -420px;
    top: 0;
    background: white;
    border-radius: .4em;
    box-shadow: 0 5px 12px rgba(0,0,0,.15);
  }

  .features-box {
    width: 360px;
    padding: 20px;
  }


  .shiny {
    color: #fff;    
    background:  #23D5AB;
    animation: shadow-pulse 1s 1;
    animation-delay: 1s;    
  }

  .shiny:hover {
    background:  rgb(34, 202, 163);
  }  

  .help-dropdown {
    padding: 0; 
    width: 260px !important; 
    background: linear-gradient(90deg, rgba(1,172,254,1) 0%, rgba(1,172,254,1) 80%, rgba(0,212,255,0) 100%);
    box-shadow: none;
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;
  }

  .navbar-help-text:hover {
    color: white !important;
  }

  .logout-dropdown {
    border-radius: 4px;
  }

  .account-header {
    padding: 10px;
    background: rgb(235, 235, 235);
    margin-bottom: 12px;
    border-radius: 4px;
  };

.logout-button {
    -webkit-font-smoothing: antialiased;
    text-size-adjust: 100%;
    -webkit-box-direction: normal;
    pointer-events: all;
    -webkit-appearance: none;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-block;
    height: 36px;
    min-width: 36px;
    outline: 0;
    overflow: hidden;
    text-decoration: none;
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: nowrap;
    border-radius: 4px;
    box-shadow: none;
    color: #1e88e5;
    line-height: 36px;
    background: 0;
    padding: 0 8px;
    border: 0;
    margin: 0 -8px 0 16px;
    transition: background .2s,box-shadow .2s,color .2s,-webkit-box-shadow .2s;
}

.logout-button:hover {
    transition: background .2s,box-shadow .2s,color .2s,-webkit-box-shadow .2s;
    background: #e8f0fe;
    border: 0;
}

.logout-button:focus:active {
    transition: background .2s,box-shadow .2s,color .2s,-webkit-box-shadow .2s;
    background: #e8f0fe;
    box-shadow: 0 1px 2px 0 rgba(60,64,67,.3),0 2px 6px 2px rgba(60,64,67,.15);
    border: 0;
}


  @keyframes shadow-pulse
  {
    0% {
      box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.15);
    }
    100% {
      box-shadow: 0 0 0 35px rgba(0, 0, 0, 0);
    }
  }


</style>